export default __webpack_public_path__ + "static/media/book.d6af1745.svg";